"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ADDRESS = require('./address');

var SessionStorage = function SessionStorage() {
  _classCallCheck(this, SessionStorage);
};

_defineProperty(SessionStorage, "get", function () {
  return JSON.parse(window.sessionStorage.getItem(ADDRESS.MEMORY));
});

_defineProperty(SessionStorage, "set", function (value) {
  if (!value) return console.error('Value cannot be null');
  return window.sessionStorage.setItem(ADDRESS.MEMORY, JSON.stringify(value));
});

_defineProperty(SessionStorage, "remove", function () {
  return window.sessionStorage.removeItem(ADDRESS.MEMORY);
});

module.exports = SessionStorage;